import axios from 'axios'

// NOTE: To make the environment vars to work, need to add Prefix
// e.g. VUE_APP_<ENV VAR>
const API_URL = process.env.VUE_APP_API_URL

export function register(userData) {
    return axios.post(`${API_URL}/api/v1/register/`, userData)
}

export function authenticate(userData) {
    // Convert via form data
    const formData = new FormData()
    formData.append('username', userData.username)
    formData.append('password', userData.password)

    return axios.post(`${API_URL}/api/v1/token/`, formData)
}

export function get_facilities() {
    return axios.get(`${API_URL}/api/v1/facilities/`)
}

export function check_username(username) {
    return axios.post(`${API_URL}/api/v1/checkUsername/`, username)
}

/* Check mobile number */
export function check_mobile_num(code) {
    return axios.post(`${API_URL}/api/v1/checkMobileNum/`, code)
}

/* Secretary APIs*/
export function get_secretary_schedules(jwt) {
    return axios.get(`${API_URL}/api/v1/secretary/schedules/`, { headers: { 'Authorization': `Bearer ${jwt}` }})
}

export function post_secretary_schedules(schedules, jwt) {
    return axios.post(`${API_URL}/api/v1/secretary/schedules/`, schedules, { headers: { 'Authorization': `Bearer ${jwt}`}})
}

/* Secretary APIs*/
export function get_secretary_users(jwt) {
    return axios.get(`${API_URL}/api/v1/secretary/users/`, { headers: { 'Authorization': `Bearer ${jwt}` }})
}

/* Service User APIs*/
export function post_user(user_details) {
    return axios.post(`${API_URL}/api/v1/service_user/`, user_details)
}

export function generate_service_user_otp(mobile_number) {
    return axios.post(`${API_URL}/api/v1/service_user/otp/`, mobile_number)
}


export function get_available_schedules(jwt) {
    return axios.get(`${API_URL}/api/v1/service_user/schedules/`, { headers: { 'Authorization': `Bearer ${jwt}` }})
}

export function post_user_schedule(jwt, schedule) {
    return axios.post(`${API_URL}/api/v1/service_user/schedules/`, schedule, { headers: { 'Authorization': `Bearer ${jwt}`}})
}


/* Service Provider APIs*/
export function post_service_provider(user_details) {
    return axios.post(`${API_URL}/api/v1/service_provider/`, user_details)
}

export function put_meeting_url(jwt, meeting_details) {
    return axios.put(`${API_URL}/api/v1/service_provider/meeting_url/`, meeting_details, { headers: { 'Authorization': `Bearer ${jwt}` }})
}

export function get_service_provider_meeting_url(jwt) {
    return axios.get(`${API_URL}/api/v1/service_provider/meeting_url/`, {
        headers: { 'Authorization': `Bearer ${jwt}`}
    })
}

export function get_service_provider_schedules(jwt, start_date, end_date) {
    return axios.get(`${API_URL}/api/v1/service_provider/schedules/`, {
        params: {
            start_date,
            end_date
        },
        headers: { 
            'Authorization': `Bearer ${jwt}` 
        }
    })
}

export function delete_service_provider_schedule(jwt, schedule_id) {
    return axios.post(`${API_URL}/api/v1/service_provider/schedules/delete/`, schedule_id, { headers: { 'Authorization': `Bearer ${jwt}` }})
}


export function post_service_provider_schedule(jwt, schedule) {
    return axios.post(`${API_URL}/api/v1/service_provider/schedules/`,  schedule, {
        headers: { 'Authorization': `Bearer ${jwt}`}
    })
}


/* Service Provider Schedule Logs API*/
export function get_provider_schedule_logs(jwt) {
    return axios.get(`${API_URL}/api/v1/service_provider/schedule_logs/`, { headers: { 'Authorization': `Bearer ${jwt}` }})
}


/* User Notes APIs*/
export function get_user_notes(jwt) {
    return axios.get(`${API_URL}/api/v1/user_notes/`, { headers: { 'Authorization': `Bearer ${jwt}` }})
}


export function post_user_note(jwt, note) {
    return axios.post(`${API_URL}/api/v1/user_notes/`, note, { headers: { 'Authorization': `Bearer ${jwt}` }})
}

export function get_user_details(jwt){
    return axios.get(`${API_URL}/api/v1/me/`, {headers: { 'Authorization': `Bearer ${jwt}` }})
}

/* Image API*/
export function post_image(image) {
    const formData = new FormData()
    formData.append('image', image)

    return axios.post(`${API_URL}/api/v1/images/`, formData, { headers: { 'content-type': 'multipart/form-data' }})
}

/* Secretary Audit Logs API*/
export function get_secretary_audit_logs(jwt) {
    return axios.get(`${API_URL}/api/v1/secretary/audit_logs/`, { headers: { 'Authorization': `Bearer ${jwt}` }})
}

/* Forgot Password*/
export function forgot_password(email) {
    return axios.post(`${API_URL}/api/v1/forgotPassword/`, email)
}

/* Reset password */
export function reset_password(password, jwt) {
    return axios.post(`${API_URL}/api/v1/reset_password/`, password, { headers: { 'Authorization': `Bearer ${jwt}` }})
}


/* Verify user id */
export function verify_user(code) {
    return axios.post(`${API_URL}/api/v1/service_user/verify_user/`, code)
}
